import React from 'react'

type Props = { title: string, description: string }
const OnBoardingHeader:React.FC<Props> = ({ title, description }) => (
  <div className='text-center sm:mt-12 max-w-2xl mx-auto'>
    <h1 className='mb-6'>{title}</h1>
    <p className='sm:mt-8 font-light whitespace-pre-wrap'>{description}</p>
  </div>
)

export default OnBoardingHeader
